export default {
  baseStyle: {
    header: {
      fontSize: 'lg',
      fontWeight: 'semibold',
      fontFamily: 'body',
    },
  },
}
